import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { useFilterSearchParams } from "@/utils/hooksUtils";
import { DEFAULT_BUSINESS_COEFFICIENTS_REPORT_QUERY_PARAMS } from "../../commissions/productcommissionssettings/api";
import { BusinessCoefficientsReportFilterPageRequest } from "../../commissions/productcommissionssettings/types";
import { BusinessCoefficientsFilterForm } from "../components/forms/BusinessCoefficientsFilterForm";
import { BusinessCoefficientsTable } from "../components/tables/BusinessCoefficientsTable";

export const BusinessCoefficientsContainer = () => {
  const searchParams = useFilterSearchParams<BusinessCoefficientsReportFilterPageRequest>({
    params: ["institutionIds", "productGroupIds", "commissionKinds"],
    defaultQueryParamsObject: DEFAULT_BUSINESS_COEFFICIENTS_REPORT_QUERY_PARAMS,
  });

  return (
    <ContentWrapper>
      <BusinessCoefficientsFilterForm searchParams={searchParams} />

      <BusinessCoefficientsTable searchParams={searchParams} />
    </ContentWrapper>
  );
};
